var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "search-container" }, [
    _c("div", { staticClass: "position-relative flex-center padding-top-20" }, [
      _c("div", { staticClass: "search-box flex-center flex-col" }, [
        _c(
          "div",
          {
            staticClass: "search color-bg-fff flex-center",
            class: { serachInput_active: _vm.isFocus },
          },
          [
            _c("el-input", {
              staticClass: "margin-left-20",
              attrs: { placeholder: _vm.placeholder, accesskey: "v" },
              on: { focus: _vm.onFocus, blur: _vm.onBlur },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.searchChange.apply(null, arguments)
                },
              },
              model: {
                value: _vm.searchKey,
                callback: function ($$v) {
                  _vm.searchKey = $$v
                },
                expression: "searchKey",
              },
            }),
            _c(
              "div",
              {
                staticClass: "search-btn flex-center",
                on: { click: _vm.searchChange },
              },
              [
                _c("img", {
                  staticStyle: { width: "28px", height: "28px" },
                  attrs: { src: require("./static/icon_home_search.png") },
                }),
              ]
            ),
          ],
          1
        ),
      ]),
    ]),
    _c(
      "div",
      { staticClass: "flex-center margin-y-10" },
      [
        _c("span", { staticClass: "color-333 font-light font-16" }, [
          _vm._v("热门关键词："),
        ]),
        _vm._l(_vm.hotList, function (item) {
          return _c(
            "div",
            {
              key: item.id,
              staticClass:
                "font-14 padding-x-10 padding-y-2 margin-y-5 margin-right-10 font-light hotWord",
              on: {
                click: function ($event) {
                  return _vm.hotSearch(item.name)
                },
              },
            },
            [_vm._v(_vm._s(item.name))]
          )
        }),
      ],
      2
    ),
    _c(
      "div",
      {
        staticStyle: {
          width: "100%",
          height: "calc(100% - 180px)",
          "overflow-y": "scroll",
        },
      },
      [
        _c(
          "div",
          {
            staticClass: "margin-bottom-10 flex flex-align-center",
            staticStyle: { padding: "0 220px" },
          },
          [
            _c(
              "span",
              { staticClass: "color-333 font-weight font-18 margin-right-20" },
              [_vm._v("搜索结果")]
            ),
            _c("yd-common-selector", {
              attrs: { options: _vm.sortList },
              on: { input: _vm.sortChange },
              model: {
                value: _vm.sortValue,
                callback: function ($$v) {
                  _vm.sortValue = $$v
                },
                expression: "sortValue",
              },
            }),
            _vm.sortType === 1
              ? _c("i", {
                  staticClass: "el-icon-caret-bottom font-30 pointer",
                  on: {
                    click: function ($event) {
                      return _vm.handleSort(2)
                    },
                  },
                })
              : _c("i", {
                  staticClass: "el-icon-caret-top font-30 pointer",
                  on: {
                    click: function ($event) {
                      return _vm.handleSort(1)
                    },
                  },
                }),
          ],
          1
        ),
        _vm.articleList.length > 0
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading",
                  },
                ],
                staticClass: "padding-bottom-10",
                staticStyle: { overflow: "auto", margin: "0 220px" },
              },
              _vm._l(_vm.articleList, function (item) {
                return _c(
                  "div",
                  {
                    key: item.id,
                    staticClass:
                      "articleList padding-y-15 padding-x-20 margin-bottom-15 color-bg-fff",
                    on: {
                      click: function ($event) {
                        return _vm.goDetail(item.id)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "flex-between" }, [
                      _c("div", { staticClass: "flex flex-align-center" }, [
                        _c("img", {
                          staticStyle: { width: "18px", height: "18px" },
                          attrs: { src: item.icon },
                        }),
                        _c("span", {
                          staticClass:
                            "font-18 color-333 font-weight margin-left-15",
                          domProps: { innerHTML: _vm._s(item.title) },
                        }),
                      ]),
                      _c(
                        "div",
                        { staticClass: "flex-center" },
                        _vm._l(item.labels, function (it, index) {
                          return _c("div", { key: index }, [
                            it && index < 3
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "label-item font-14 font-light",
                                  },
                                  [_vm._v(_vm._s(it))]
                                )
                              : _vm._e(),
                          ])
                        }),
                        0
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "padding-bottom-10 content-border" },
                      [
                        _c("div", {
                          staticClass:
                            "font-14 color-666 font-normal rich-text",
                          domProps: { innerHTML: _vm._s(item.content) },
                        }),
                      ]
                    ),
                    _c(
                      "div",
                      { staticClass: "flex flex-align-center padding-top-10" },
                      [
                        _c(
                          "span",
                          { staticClass: "color-999 font-14 margin-right-40" },
                          [_vm._v(_vm._s(item.time))]
                        ),
                        _c("div", { staticClass: "flex flex-align-center" }, [
                          _c("img", {
                            staticStyle: { width: "16px", height: "16px" },
                            attrs: {
                              src: require("./static/icon_article_pageView.png"),
                            },
                          }),
                          _c(
                            "span",
                            { staticClass: "color-999 font-14 margin-left-5" },
                            [
                              _vm._v(
                                _vm._s(
                                  item.pageView > 999 ? "999+" : item.pageView
                                )
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]
                )
              }),
              0
            )
          : _c(
              "div",
              {
                staticClass: "flex-center flex-col",
                staticStyle: { height: "48vh" },
              },
              [
                _c("img", {
                  staticStyle: { width: "270px", height: "196px" },
                  attrs: { src: require("./static/icon_article_ default.png") },
                }),
                _c("div", { staticClass: "color-666 font-light" }, [
                  _vm._v("没有找到对应的内容，您可以换一个关键词搜索试试~"),
                ]),
              ]
            ),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "text-right margin-top-20",
        staticStyle: { width: "100%" },
      },
      [
        _c("el-pagination", {
          attrs: {
            background: "",
            "current-page": _vm.paginations.current,
            "page-sizes": [10, 20, 50, 100],
            "page-size": _vm.paginations.size,
            layout: "total, sizes, prev, pager, next, jumper",
            total: _vm.total,
          },
          on: {
            "size-change": _vm.handleSizeChange,
            "current-change": _vm.handleCurrentChange,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }